import * as React from "react";

import { cn } from "../../utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  TextareaProps & {
    className: string;
    containerClassname?: string;
    maxLength?: number;
    value?: string | number | readonly string[];
  }
>(({ className, containerClassname, maxLength, value, ...props }, ref) => {
  if (typeof value === "number") value = value.toString();
  return (
    <div className={cn("relative", containerClassname)}>
      <textarea
        className={cn(
          "border-input placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[60px] w-full rounded-md border bg-transparent px-3 py-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        maxLength={maxLength}
        value={value}
        {...props}
      />
      {maxLength && (
        <p className="absolute bottom-2 right-2 text-xs text-gray-500">
          {value?.length}/{maxLength}
        </p>
      )}
    </div>
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
